import { useEffect, useState } from "react";
import QRCode from "qrcode";

type CodigoQRProps = {
  valor: string;
  tamano?: number;
  titulo?: string;
};

export default function CodigoQR({ valor, tamano = 220, titulo }: CodigoQRProps) {
  const [dataUrl, setDataUrl] = useState<string>("");
  const [copiado, setCopiado] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!valor) return;
    let activo = true;

    QRCode.toDataURL(valor, {
      width: tamano * 2, // Retinal high resolution
      margin: 1.5,
      errorCorrectionLevel: "M",
      color: {
        dark: "#1e293b",
        light: "#ffffff",
      },
    })
      .then((url) => {
        if (activo) setDataUrl(url);
      })
      .catch((err) => {
        if (activo) setError(err instanceof Error ? err.message : "Error al generar QR");
      });

    return () => {
      activo = false;
    };
  }, [valor, tamano]);

  const copiarAlPortapapeles = async () => {
    try {
      await navigator.clipboard.writeText(valor);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2500);
    } catch {
      // Fallback si clipboard api falla
      const input = document.createElement("input");
      input.value = valor;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2500);
    }
  };

  const descargarQR = () => {
    if (!dataUrl) return;
    const a = document.createElement("a");
    a.href = dataUrl;
    a.download = `qr-invitacion-${Date.now()}.png`;
    a.click();
  };

  if (error) {
    return <p className="err">{error}</p>;
  }

  return (
    <div className="qr-contenedor">
      {titulo && <h3 className="qr-titulo">{titulo}</h3>}

      <div className="qr-marco" style={{ width: tamano, height: tamano }}>
        {dataUrl ? (
          <img src={dataUrl} alt="Código QR de invitación" className="qr-imagen" />
        ) : (
          <div className="qr-cargando">
            <span className="spinner-chico" />
          </div>
        )}
      </div>

      <div className="qr-enlace-box">
        <input
          type="text"
          readOnly
          value={valor}
          className="qr-input-url"
          onClick={(e) => (e.target as HTMLInputElement).select()}
        />
      </div>

      <div className="qr-acciones">
        <button
          type="button"
          className="boton-primario boton-chico"
          onClick={copiarAlPortapapeles}
        >
          {copiado ? "✓ ¡Enlace copiado!" : "📋 Copiar enlace"}
        </button>
        <button
          type="button"
          className="boton boton-chico"
          onClick={descargarQR}
          disabled={!dataUrl}
        >
          ⬇️ Guardar imagen QR
        </button>
      </div>
    </div>
  );
}
